'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import {
  installNavBaselineGlobals,
  isPerfNavEnabled,
  measurePaintSince,
  recordNavBaseline,
} from '@/lib/perf/navBaseline';

/**
 * Opt-in M1 probe. Active only when localStorage.bb-perf-nav === '1'.
 * Records pathname transitions after first paint settle (~rAF×2 + 50ms).
 */
export default function NavBaselineProbe() {
  const pathname = usePathname();
  const startRef = useRef<number | null>(null);
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    installNavBaselineGlobals();
  }, []);

  useEffect(() => {
    if (!isPerfNavEnabled()) return;
    // Mark start on path change; first mount counts as cold-ish for that route.
    startRef.current = performance.now();
    const route = pathname;
    const from = prevPath.current;
    prevPath.current = pathname;

    let cancelled = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.setTimeout(() => {
          if (cancelled || startRef.current == null) return;
          const ms = measurePaintSince(startRef.current);
          recordNavBaseline({
            route,
            ms,
            note: from == null ? 'mount' : `from:${from}`,
          });
          // eslint-disable-next-line no-console
          console.info('[bb-perf-nav]', route, `${Math.round(ms)}ms`, window.__bbPerfNav?.rows?.()?.slice(-1));
        }, 50);
      });
    });

    return () => {
      cancelled = true;
    };
  }, [pathname]);

  return null;
}
